
// 批量设置公开画面
Vue.component("necessary_modal", {
  props: {
    course_info: {
      type: Array,
      default: {}
    },
    tree_info: {
      type: Array,
      default: []
    },
    is_join: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      list: [],
      numbers: {
        total: 0,
        must: 0,
        select: 0
      }
    };
  },
  mounted() {
    //计算所有内容数量
    let total = 0, select = 0, must = 0
    let allContent = []
    function getNum(arr) {
      arr.map(el => {
        if (el.info.resource_attributes) {
          allContent.push(el.info)
        }
        if (el.childInfo) {
          getNum(el.childInfo)
        }
      })
    }
    getNum(this.tree_info)
    total = allContent.length
    if (this.course_info.necessaryLearn == 1) {
      //全部必学
      must = total
    } else {
      //部分必学
      if (this.course_info.necessaryLearnType.includes(0)) {
        //按类型
        must = allContent.filter(info => {
          return (
            (this.course_info.necessaryLearnType.includes(2) && (info.resourse_type == 'video' || info.resourse_type == 'audio') && info.resource_attributes == 'courseware') ||
            (this.course_info.necessaryLearnType.includes(3) && info.resourse_type == 'document' && info.resource_attributes == 'courseware') ||
            (this.course_info.necessaryLearnType.includes(4) && info.resourse_type == 'picture' && info.resource_attributes == 'courseware') ||
            (this.course_info.necessaryLearnType.includes(5) && !info.resourse_type && info.resource_attributes == 'courseware') ||
            (this.course_info.necessaryLearnType.includes(6) && info.resource_attributes == 'homework') ||
            (this.course_info.necessaryLearnType.includes(7) && info.resource_attributes == 'reference') ||
            (this.course_info.necessaryLearnType.includes(8) && info.resource_attributes == 'hyperlink')
          )
        }).length
        select = total - must
      } else {
        //自定义
        must = allContent.filter(info => this.course_info.necessaryLearnResourceId.includes(info.guid_)).length
        select = total - must
      }
    }
    this.numbers.total = total
    this.numbers.select = select
    this.numbers.must = must
    //首次加入学习自动弹出
    if (this.is_join) {
      this.autoOpen()
    }
  },
  methods: {
    autoOpen() {
      if(!this.getIfPc()) return
      try {
        let autoNecessaryModal = JSON.parse(localStorage.getItem('autoNecessaryModal') || "[]")
        let id = this.course_info.guid_
        if (!autoNecessaryModal.includes(id)) {
          autoNecessaryModal.push(id)
          localStorage.setItem('autoNecessaryModal', JSON.stringify(autoNecessaryModal))
          this.visible = true
        }
      } catch (err) {
        localStorage.setItem('autoNecessaryModal', JSON.stringify([]))
      }
    }
  },
  template: `
  <div class="necessary_modal">
    <div class="necessary_btn" @click="visible = true">
        <iconfont type="icondangjian_gongzuoyaoqiu"></iconfont>
        <span>课程学习要求</span>
    </div>
    <el-dialog :visible.sync="visible" title="课程学习要求" :modal="false">
        <template slot="title"><iconfont width="1.4em" height="1.4em" type="icondangjian_gongzuoyaoqiu"></iconfont>{{$t('课程学习要求')}}</template>
        <div class="necessary_info">
            <div>本课程教学内容区分<span>必学</span>与<span>选学</span></div>
            <div>必学内容：<span>{{numbers.must}}</span> 个，需全部完成学习</div>
            <div v-if="numbers.select">选学内容：<template v-if="course_info.necessaryLearnNumber"><span>{{numbers.select}}</span> 个，请选择 <span>{{course_info.necessaryLearnNumber}}<span> 个完成学习</template><template v-else>可根据个人情况选择学习</template></div>
        </div>
    </el-dialog>
  </div>
  `,
});